export var REQUIRED_PARAMS_FOR_TRX_TYPE = {
  abn_ideal: ['customer_email', 'remote_ip', 'country'],
  account_verification: ['address1', 'city', 'zip_code'],
  argencard: ['last_name', 'first_name', 'country', 'customer_email'],
  astropay_card: ['last_name', 'first_name', 'country'],
  astropay_direct: ['last_name', 'first_name', 'country'],
  aura: ['last_name', 'first_name', 'country', 'customer_email', 'zip_code', 'address1'],
  baloto: ['last_name', 'first_name', 'country', 'customer_email'],
  banamex: ['last_name', 'first_name', 'country', 'customer_email'],
  banco_de_chile: ['last_name', 'first_name', 'country', 'customer_email'],
  banco_de_occidente: ['last_name', 'first_name', 'country', 'customer_email'],
  banco_do_brasil: ['last_name', 'first_name', 'country', 'customer_email', 'zip_code', 'address1'],
  bank_payout: ['first_name', 'last_name', 'city'],
  bcmc: ['last_name', 'first_name', 'country'],
  boleto: ['last_name', 'first_name', 'country', 'customer_email', 'zip_code', 'address1'],
  bancomer: ['last_name', 'first_name', 'country', 'customer_email'],
  bradesco: ['last_name', 'first_name', 'country', 'customer_email', 'zip_code', 'address1'],
  cabal: ['last_name', 'first_name', 'country', 'customer_email'],
  cartao_mercado_livre: ['last_name', 'first_name', 'country', 'customer_email', 'zip_code', 'address1'],
  carulla: ['last_name', 'first_name', 'country', 'customer_email'],
  cashu: ['customer_email', 'remote_ip', 'country'],
  cencosud: ['last_name', 'first_name', 'country', 'customer_email'],
  citadel_payin: ['country', 'customer_email', 'first_name', 'last_name'],
  citadel_payout: ['country', 'customer_email', 'first_name', 'last_name'],
  davivienda: ['last_name', 'first_name', 'country', 'customer_email'],
  efecty: ['last_name', 'first_name', 'country', 'customer_email'],
  elo: ['last_name', 'first_name', 'country', 'customer_email', 'zip_code', 'address1'],
  entercash: ['last_name', 'first_name', 'country'],
  emprese_de_energia: ['last_name', 'first_name', 'country', 'customer_email'],
  eps: ['last_name', 'first_name', 'country'],
  giropay: ['last_name', 'first_name', 'country'],
  hipercard: ['last_name', 'first_name', 'country', 'customer_email', 'zip_code', 'address1'],
  inpay: ['customer_email', 'remote_ip', 'country'],
  ideal: ['last_name', 'first_name', 'country'],
  idebit_payin: ['country'],
  insta_debit_payin: ['country'],
  instant_transfer: ['last_name', 'first_name', 'country'],
  itau: ['last_name', 'first_name', 'country', 'customer_email', 'zip_code', 'address1'],
  invoice: ['address1', 'city', 'country', 'customer_email', 'customer_phone', 'first_name', 'last_name', 'state', 'zip_code'],
  invoice_capture: ['address1', 'city', 'country', 'customer_email', 'customer_phone', 'first_name', 'last_name', 'state', 'zip_code'],
  invoice_refund: ['address1', 'city', 'country', 'customer_email', 'customer_phone', 'first_name', 'last_name', 'state', 'zip_code'],
  link: ['last_name', 'first_name', 'country', 'customer_email'],
  my_bank: ['last_name', 'first_name', 'country'],
  multibanco: ['last_name', 'first_name', 'country'],
  naranja: ['last_name', 'first_name', 'country', 'customer_email'],
  nativa: ['last_name', 'first_name', 'country', 'customer_email'],
  neteller: ['customer_email', 'remote_ip', 'country'],
  online_banking: ['last_name', 'first_name', 'country', 'customer_email'],
  oxxo: ['last_name', 'first_name', 'country', 'customer_email'],
  p24: ['customer_email', 'remote_ip', 'country'],
  pago_facil: ['last_name', 'first_name', 'country', 'customer_email'],
  paysafecard: ['customer_email', 'remote_ip', 'country'],
  payu: ['last_name', 'first_name', 'country', 'customer_email'],
  poli: ['customer_email', 'remote_ip', 'country'],
  post_finance: ['last_name', 'first_name', 'country'],
  ppro: ['customer_email', 'remote_ip', 'country'],
  pse: ['last_name', 'first_name', 'country', 'customer_email'],
  qiwi: ['last_name', 'first_name', 'country', 'customer_phone'],
  rapi_pago: ['last_name', 'first_name', 'country', 'customer_email'],
  redpagos: ['last_name', 'first_name', 'country', 'customer_email'],
  safetypay: ['last_name', 'first_name', 'country', 'customer_email'],
  santander: ['last_name', 'first_name', 'country', 'customer_email'],
  santander_cash: ['last_name', 'first_name', 'country', 'customer_email'],
  sct_payout: ['last_name', 'first_name'],
  sdd_recurring_sale: ['last_name', 'first_name'],
  sdd_refund: ['last_name', 'first_name'],
  sdd_init_recurring_sale: ['last_name', 'first_name'],
  sdd_sale: ['last_name', 'first_name'],
  sofort: ['customer_email', 'remote_ip', 'country'],
  surtimax: ['last_name', 'first_name', 'country', 'customer_email'],
  tarjeta_shopping: ['last_name', 'first_name', 'country', 'customer_email'],
  african_mobile_sale: ['customer_phone'],
  african_mobile_payout: ['customer_phone'],
  trustly_sale: ['remote_ip', 'customer_email', 'country'],
  webmoney: ['customer_email', 'remote_ip', 'country'],
  webpay: ['last_name', 'first_name', 'country', 'customer_email'],
  wechat: ['usage', 'country'],
  zimpler: ['last_name', 'first_name', 'country', 'customer_email']
};